import { useState } from "react";
import Button from "../../utils/components/Button";
import Input from "../../utils/components/Input";
import WSLogo from "../../static/crane-ws-login-logo.svg";
import { FaFacebookF, FaInstagram, FaKey, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
import { guest } from "../../App/routes";
import API from "../../utils/API";
import { login } from "../../utils/redux/auth/authActions";
import { connect } from "react-redux";
import { getYear } from "date-fns";
import decodeJWT from "../../utils/helpers/decodeJWT";
import toastr from "toastr";
import {
  browserSupportsWebAuthn,
  startAuthentication,
} from "@simplewebauthn/browser";

const Login = ({ translate, login, settings }) => {
  // eslint-disable-next-line no-unused-vars
  const [firstShow, setFirstShow] = useState(false); // Burası ne işe yarıyor tam olarak?

  const [userInfo, setUserInfo] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [isSending, setIsSending] = useState(false);
  const [passkeySupported] = useState(() => browserSupportsWebAuthn());

  const handleChange = (e) =>
    setUserInfo({
      ...userInfo,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });

  const completeLogin = async (data, rememberMe) => {
    const { sub: id } = decodeJWT(data.access_token);

    const { data: userResponse } = await API.getUserData(id, data.access_token);

    const { data: user } = userResponse;

    const loginUser = {
      ...data,
      rememberMe,
      id: user.id,
      name: user.name,
      email: user.email,
      title: user.title,
      lang: user.lang,
      role: user.application_role,
      avatar: user.avatar,
      company: user.company,
    };

    login(loginUser);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { email, password, rememberMe } = userInfo;

    if (!email || !password) {
      return;
    }

    setIsSending(true);

    API.login({ email, password })
      .then(({ data: res }) => completeLogin(res.data, rememberMe))
      .catch(() => setIsSending(false));
  };

  const handlePasskeyLogin = async () => {
    if (isSending) return;
    setIsSending(true);

    let options;
    try {
      const { data: res } = await API.postData(
        "/auth/passkeys/authentication_options"
      );
      options = res.data;
    } catch (error) {
      setIsSending(false);
      return;
    }

    let assertion;
    try {
      assertion = await startAuthentication({ optionsJSON: options });
    } catch (error) {
      setIsSending(false);
      if (error.name !== "NotAllowedError" && error.name !== "AbortError") {
        toastr.error(translate("auth.login.passkey_error"));
      }
      return;
    }

    try {
      const { data: res } = await API.postData(
        "/auth/passkeys/authentication",
        assertion
      );
      await completeLogin(res.data, userInfo.rememberMe);
    } catch (error) {
      setIsSending(false);
    }
  };

  return (
    <div className="login container-fluid d-flex flex-column align-items-center justify-content-center px-3 py-1 overflow-auto">
      {!firstShow && (
        <div className="row d-flex align-items-center justify-content-center mt-5">
          <div className="col-md-12 col-lg-6 d-flex flex-column align-items-center mt-4">
            <img height={145} src={WSLogo} alt="logo" />
            <p className="fw-bold text-center my-4 pt-2 fs-5 mt-5">
              {translate("auth.login.title")}
            </p>
          </div>
          <div className="col-md-12 col-lg-8">
            <form action="login" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <Input
                    type="email"
                    name="email"
                    className="d-block border-dark p-3"
                    placeholder={translate("email")}
                    required={true}
                    value={userInfo.email}
                    onChange={handleChange}
                    inputProps={{
                      readOnly: isSending,
                    }}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <Input
                    type="password"
                    name="password"
                    className="d-block border-dark p-3"
                    placeholder={translate("password")}
                    required={true}
                    value={userInfo.password}
                    onChange={handleChange}
                    inputProps={{
                      readOnly: isSending,
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-between mt-3">
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input mb-1 me-2"
                        name="rememberMe"
                        type="checkbox"
                        checked={userInfo.rememberMe}
                        id="rememberMe"
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="rememberMe">
                        {translate("auth.login.remember_me")}
                      </label>
                    </div>
                    <Link
                      to={guest.forgotPassword.link}
                      className="ms-0 pt-1 text-orange"
                    >
                      {translate("auth.login.forgot_password_link")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Button
                    type="submit"
                    disabled={isSending}
                    className="btn-orange text-white w-100 mt-3 p-2"
                  >
                    {translate("auth.login.form_button")}
                  </Button>
                </div>
              </div>
            </form>
            {passkeySupported && (
              <>
                <div className="d-flex align-items-center mt-3">
                  <hr className="flex-grow-1 m-0" />
                  <span className="text-secondary mx-3">
                    {translate("auth.login.passkey_divider")}
                  </span>
                  <hr className="flex-grow-1 m-0" />
                </div>
                <Button
                  type="button"
                  disabled={isSending}
                  onClick={handlePasskeyLogin}
                  className="btn-outline-dark w-100 mt-3 p-2 d-flex align-items-center justify-content-center"
                >
                  <FaKey className="me-2" />
                  {translate("auth.login.passkey_button")}
                </Button>
              </>
            )}
          </div>
        </div>
      )}
      {firstShow && (
        <div className="row d-flex align-items-center justify-content-center mt-5">
          <div className="col-md-12 col-lg-9 d-flex flex-column align-items-center mt-4">
            <img height={150} src={WSLogo} alt="logo" />
          </div>
          <div className="col-md-12 col-lg-9">
            <div className="d-flex flex-column justify-content-between mt-3">
              <div className="terms mb-3">
                Example Terms and Conditions of Use
              </div>
              <div className="form-check d-flex align-items-center">
                <input
                  className="form-check-input mb-1 me-2"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label className="form-check-label" for="flexCheckDefault">
                  Şartlar ve koşulları okudum ve kabul ediyorum.
                </label>
              </div>
              <Button type="submit" className="btn-orange w-100 mt-3 p-2">
                {translate("page_titles.login")}
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="row w-100 mt-auto pb-3">
        <div className="col-12">
          <div className="d-flex flex-wrap align-items-center justify-content-between mt-auto">
            <p className="m-0">Copyright &copy; {getYear(new Date())}</p>
            <p className="m-0">Terms and Conditions</p>
            <div>
              <a href="#!" className="me-4">
                <FaInstagram />
              </a>
              <a href="#!" className="me-4">
                <FaTwitter />
              </a>
              <a href="#!">
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  login: (user) => dispatch(login(user)),
});

export default connect(null, mapDispatchToProps)(Login);
